/* ============================================================
   mt-ab-variants.js — variant CONFIG (data only).
   Loaded synchronously in <head> BEFORE mt-ab.js.

   ## Source of truth
   `Tarot Content/Ads/Millennial/Testing/Cross-Sprint/Phase A LP Copy Review.xlsx`
   Tabs: OCCULT-Belief, META-Therapy, MILLENNIAL-Era, SASSY-Polite.
   The "SASSY-Polite" tab is emitted as variant key `sassy_attitude` (renamed
   2026-05-12 — Attitude won engagement; Polite's lone sale was Sprint 4 noise).

   ## Preview a variant
   https://millennialtarot.com/?ab_theme_v1=occult_belief
   https://millennialtarot.com/?ab_theme_v1=meta_therapy
   https://millennialtarot.com/?ab_theme_v1=millennial_era
   https://millennialtarot.com/?ab_theme_v1=sassy_attitude
   https://millennialtarot.com/?ab_theme_v1=default
   ============================================================ */
window.MT_AB_VARIANTS = {

  theme_v1: {
    description: 'Phase A: theme axis on single-deck. URL: ?ab_theme_v1=<variant>',
    weights: {
      default: 100,
      occult_belief: 0,
      meta_therapy: 0,
      millennial_era: 0,
      sassy_attitude: 0
    },
    variants: {
      default: {},

      // ----- OCCULT-Belief — "the woo isn't you" · 6.12% CTR · 36% eng60 -----
      occult_belief: {
        text: {
          'hero.eyebrow': '✦ WOO-LIGHT. SKEPTIC-FRIENDLY.',
          'hero.h1': 'Tarot with no belief or buy-in required.',
          'hero.h2': 'Because the woo isn\'t you.',
          'hero.body': 'Cards called Sunday Scaries (9 of Swords), Quarter-Life Crisis (Judgement), and Dumpster Fire (the Tower). Pull one. It instantly makes sense.',
          'hero.featured-quote': '"I get what the cards are trying to say immediately. The traditional deck didn\'t resonate as much, but this one speaks directly to my life experiences."',
          'hero.featured-quote-attr': '— @fairlighttarot, Instagram',
          'why.eyebrow': '✦ Why We Made It.',
          'why.h1': 'We like Tarot. But it required belief or buy-in. This doesn\'t.',
          'why.sub': 'Same 78 cards. No belief required.',
          'why.before-content': 'You pull a card? "Not really my thing..."',
          'why.before-body': 'It\'s a guy in a robe holding a stick. You\'re supposed to buy into the universe to make him meaningful. You don\'t, and shouldn\'t have to.',
          'why.before-bullet-1': '❌ Get told to "trust the universe"',
          'why.before-bullet-2': '❌ Try to commit to a framework you didn\'t sign up for',
          'why.before-bullet-3': '❌ Put the deck away with the rest of the woo',
          'why.after-content': 'You pull a card? "Damn, I know what that\'s about."',
          'why.after-body': 'It\'s Big D Energy. You don\'t need a guidebook to tell you what that means. You\'ve already lived this card.',
          'why.after-bullet-1': '✦ Pull a card. Read the name.',
          'why.after-bullet-2': '✦ Instant understanding. No decoding required.',
          'why.after-bullet-3': '✦ That\'s a reading. You\'re doing it.',
          'why.featured-quote': '"I don\'t believe the cards predict anything. I see them more as a way to reflect and think differently."',
          'why.featured-quote-attr': '— Reddit, r/SecularTarot',
          'demo.eyebrow': '✦ NOT SURE YOU BUY IT?',
          'demo.h1': 'Pull a card. Reflection, not prediction.',
          'demo.featured-quote': '"Didn\'t fully buy into tarot as a thing."',
          'demo.featured-quote-attr': '— Stine, Customer',
          'guidebook.eyebrow': '✦ 132+ Pages of Real Tarot.',
          'guidebook.h1': 'Real tarot. Woo-light and no buy-in.',
          'guidebook.sub': '132+ pages that make the meaning clear as day with some gentle sass. Plain English and color coordinated pages. Each deck comes with it\'s own guidebook.',
          'guidebook.structure-1': '"TL;DR" The whole reading in one line if that\'s all you need.',
          'guidebook.structure-2': '"The Sitch." What the card is actually saying about your week.',
          'guidebook.structure-3': '"Real Talk." The deeper guidance — what to do with it, said plainly.',
          'guidebook.structure-4': '"Reverse, Reverse." When the vibe flips, we tell you exactly how.',
          'guidebook.featured-quote': '"Everything I hoped it would be: entertaining, spot on, and in many cases, incredibly thought-provoking."',
          'guidebook.featured-quote-attr': '— @queen.of.arcana, Instagram',
          'reviews.eyebrow': '✦ From Tarot Creators and Real Owners.',
          'reviews.h1': 'Used nightly by people who don\'t buy the woo.',
          'reviews.featured': '"Didn\'t fully buy into tarot as a thing."',
          'reviews.featured-attribution': 'Stine, Customer',
          'founder.eyebrow': '✦ Who Made This. And Why.',
          'founder.h1': 'Skeptical, spiritual, somewhere in between.',
          'founder.body': 'Designed screens at Apple. Spotted that millennials left religion but still craved reflection. Built Millennial Tarot because spiritual tools shouldn\'t require a decoder ring.',
          'founder.featured-quote': '"It captures the feeling of being a millennial in this world perfectly."',
          'founder.featured-quote-attr': '— @midheaventarot, Instagram',
          'founder.scott-bio': 'Ex-Apple UX designer. Started Millennial Tarot because spiritual tools shouldn\'t require a decoder ring or a worldview. Refined the deck across eight months in a Subaru and two Pacific Northwest retreat centers.',
          'inthewild.quote-2': '"It gives me a different lens to think about something — almost like a prompt that helps me step back and see things differently. It\'s grounding in that way."',
          'inthewild.quote-2-attr': '— Caroline, Customer',
          'founder.hailey-bio': 'Moved Seattle to London on an Eat, Pray, Love impulse, answered a job ad for "Gen Z tarot writer" having never had a reading, and wrote an unhinged Empress card that got her the gig. Now lives in Germany finishing her Master\'s in global trade.'
        }
      },

      // ----- META-Therapy — "tarot that's been to therapy" · 9.41% CTR -----
      meta_therapy: {
        text: {
          'hero.eyebrow': '✦ THERAPY-FLUENT. SELF-AWARE.',
          'hero.h1': 'Tarot that\'s been to therapy.',
          'hero.h2': 'Because the wisdom felt outdated.',
          'hero.body': 'Cards called Sunday Scaries (9 of Swords), Quarter-Life Crisis (Judgement), and Dumpster Fire (the Tower). Pull one. It instantly makes sense.',
          'hero.featured-quote': '"Tough love, truth, discernment, being held, wisdom."',
          'hero.featured-quote-attr': '— Jade, Survey',
          'why.eyebrow': '✦ Why We Made It.',
          'why.h1': 'We like Tarot. But it hadn\'t been to therapy. This has.',
          'why.sub': 'Same 78 cards. Therapy-fluent without performing therapy.',
          'why.before-content': 'You pull a card? "Not really my thing..."',
          'why.before-body': 'It\'s a guy in a robe holding a stick. The guidebook reads like it was written before therapy was invented. You can\'t get anything actionable from it.',
          'why.before-bullet-1': '❌ Read about your "shadow self"',
          'why.before-bullet-2': '❌ Try to find actionable insight, get mystical reframes',
          'why.before-bullet-3': '❌ Put the deck away. It doesn\'t speak how you think.',
          'why.after-content': 'You pull a card? "Damn, I know what that\'s about."',
          'why.after-body': 'It\'s Big D Energy. The guidebook talks like a friend who\'s done the processing. Same wisdom, made for what came up this week.',
          'why.after-bullet-1': '✦ Pull a card. Read the name.',
          'why.after-bullet-2': '✦ Instant understanding. No decoding required.',
          'why.after-bullet-3': '✦ That\'s a reading. You\'re doing it.',
          'why.featured-quote': '"Tough love, truth, discernment, being held, wisdom."',
          'why.featured-quote-attr': '— Jade, Survey',
          'demo.eyebrow': '✦ WHAT CAME UP?',
          'demo.h1': 'Pull a card. What your therapist would say.',
          'demo.featured-quote': '"I didn\'t expect it to work so well for deeper readings."',
          'demo.featured-quote-attr': '— @TheNewMoonTarot, 150K YouTube',
          'guidebook.eyebrow': '✦ 132+ Pages of Real Tarot.',
          'guidebook.h1': 'Real tarot. Therapy-fluent and self-aware.',
          'guidebook.sub': '132+ pages that make the meaning clear as day with some gentle sass. Plain English and color coordinated pages. Each deck comes with it\'s own guidebook.',
          'guidebook.structure-1': '"TL;DR" The whole reading in one line if that\'s all you need.',
          'guidebook.structure-2': '"The Sitch." What the card is actually saying about your week.',
          'guidebook.structure-3': '"Real Talk." The deeper guidance — what to do with it, said plainly.',
          'guidebook.structure-4': '"Reverse, Reverse." When the vibe flips, we tell you exactly how.',
          'guidebook.featured-quote': '"Everything I hoped it would be: entertaining, spot on, and in many cases, incredibly thought-provoking."',
          'guidebook.featured-quote-attr': '— @queen.of.arcana, Instagram',
          'reviews.eyebrow': '✦ From People Who Take It Seriously.',
          'reviews.h1': 'Used nightly to process the week.',
          'reviews.featured': '"Tough love, truth, discernment, being held, wisdom."',
          'reviews.featured-attribution': 'Jade, Survey',
          'founder.eyebrow': '✦ Who Made This. And Why.',
          'founder.h1': 'Skeptical, spiritual, somewhere in between.',
          'founder.body': 'Designed screens at Apple. Spotted that millennials wanted reflection tools that weren\'t therapy or religion. Built Millennial Tarot to be a cool therapist who curses occasionally.',
          'founder.featured-quote': '"It captures the feeling of being a millennial in this world perfectly."',
          'founder.featured-quote-attr': '— @midheaventarot, Instagram',
          'founder.scott-bio': 'Ex-Apple UX designer. Started Millennial Tarot to be a tool for reflection that wasn\'t trying to be therapy or religion. Refined the deck across eight months in a Subaru and two Pacific Northwest retreat centers, where the patterns kept showing up.',
          'inthewild.quote-2': '"I get what the cards are trying to say immediately. The traditional deck didn\'t resonate as much, but this one speaks directly to my life experiences."',
          'inthewild.quote-2-attr': '— @fairlighttarot, Instagram',
          'founder.hailey-bio': 'Moved Seattle to London on an Eat, Pray, Love impulse, answered a job ad for "Gen Z tarot writer" having never had a reading, and wrote an unhinged Empress card that got her the gig. Now lives in Germany finishing her Master\'s in global trade.'
        }
      },

      // ----- MILLENNIAL-Era — "tarot that grew up with you" · 5.44% CTR · 46% eng60 · $55 bundle sale -----
      millennial_era: {
        text: {
          'hero.eyebrow': '✦ TAROT That Gets Y2K AND THE HOUSING CRISIS',
          'hero.h1': 'Tarot that gets being a Millennial.',
          'hero.h2': 'Updated for how we work, live and love.',
          'hero.body': 'Cards called Funemployed (the Hanged Man), Student Loans (Death), and Sunday Scaries (9 of Swords). Pull one. You\'ve already lived this card.',
          'hero.featured-quote': '"It captures the feeling of being a millennial in this world perfectly."',
          'hero.featured-quote-attr': '— @midheaventarot, Instagram',
          'why.eyebrow': '✦ Why We Made It.',
          'why.h1': 'We like Tarot. But it didn\'t get how we live. This does.',
          'why.sub': 'Same 78 cards. For Y2K, AIM, flip phones, and everything since.',
          'why.before-content': 'You pull a card? "Not really my thing..."',
          'why.before-body': 'It\'s a guy in a robe holding a stick. He\'s from a century without student loans, situationships, or quarter-life crisis. You can\'t map his life to yours.',
          'why.before-bullet-1': '❌ Read the guidebook, Google what a "Hierophant" is',
          'why.before-bullet-2': '❌ Try to map "wands" to your actual life',
          'why.before-bullet-3': '❌ Realize this wasn\'t made for your generation',
          'why.after-content': 'You pull a card? "Damn, I know what that\'s about."',
          'why.after-body': 'It\'s Big D Energy. It\'s Sunday Scaries. It\'s Funemployed. Tarot that lived through the same decades you did.',
          'why.after-bullet-1': '✦ Pull a card. Recognize a Sunday Scaries.',
          'why.after-bullet-2': '✦ See yourself in Funemployed.',
          'why.after-bullet-3': '✦ Tarot that grew up with you.',
          'why.featured-quote': '"A love letter to the generation. Very accurate modernization."',
          'why.featured-quote-attr': '— @callingcorners, Instagram',
          'demo.eyebrow': '✦ YOUR LIFE, ON A CARD.',
          'demo.h1': 'Pull a card. See yourself in Sunday Scaries.',
          'demo.featured-quote': '"A love letter to the generation."',
          'demo.featured-quote-attr': '— @callingcorners, Instagram',
          'guidebook.eyebrow': '✦ 132+ Pages of Real Tarot.',
          'guidebook.h1': 'Real tarot. Millennial-fluent.',
          'guidebook.sub': '132+ pages that make the meaning clear as day with some gentle sass. Plain English and color coordinated pages. Each deck comes with it\'s own guidebook.',
          'guidebook.structure-1': '"TL;DR" The whole reading in one line if that\'s all you need.',
          'guidebook.structure-2': '"The Sitch." What the card is actually saying about your week.',
          'guidebook.structure-3': '"Real Talk." The deeper guidance — what to do with it, said plainly.',
          'guidebook.structure-4': '"Reverse, Reverse." When the vibe flips, we tell you exactly how.',
          'guidebook.featured-quote': '"Everything I hoped it would be: entertaining, spot on, and in many cases, incredibly thought-provoking."',
          'guidebook.featured-quote-attr': '— @queen.of.arcana, Instagram',
          'reviews.eyebrow': '✦ From Millennial Owners and Tarot Creators.',
          'reviews.h1': 'Used by the generation that lived it.',
          'reviews.featured': '"It captures the feeling of being a millennial in this world perfectly."',
          'reviews.featured-attribution': '@midheaventarot, Instagram',
          'founder.eyebrow': '✦ Who Made This. And Why.',
          'founder.h1': 'Skeptical, spiritual, somewhere in between.',
          'founder.body': 'Designed screens at Apple. Built Millennial Tarot for his generation: Y2K, AIM, student loans, situationships. Refined the deck across eight months in a Subaru.',
          'founder.featured-quote': '"Kind of like an inside joke or secret that hits differently because it\'s millennial-themed."',
          'founder.featured-quote-attr': '— DaVonne, Customer',
          'founder.scott-bio': 'Ex-Apple UX designer and millennial. Built Millennial Tarot for his generation. Y2K, AIM, student loans, quarter-life crisis. Refined the deck across eight months in a Subaru and two Pacific Northwest retreat centers.',
          'inthewild.quote-2': '"Millennial humor at its best — \'dumpster fire\' for the Tower is perfect. Sunday scaries for the Nine of Swords? Genius!"',
          'inthewild.quote-2-attr': '— @TheNewMoonTarot, 150K YouTube',
          'founder.hailey-bio': 'Moved Seattle to London on an Eat, Pray, Love impulse, answered a job ad for "Gen Z tarot writer" having never had a reading, and wrote an unhinged Empress card that got her the gig. Now lives in Germany finishing her Master\'s in global trade.'
        }
      },

      // ----- SASSY-Attitude — "calls it like it is" · 4.89% CTR · $34 single sale (renamed from sassy_polite 2026-05-12) -----
      sassy_attitude: {
        text: {
          'hero.eyebrow': '✦ SASSY. DIRECT.',
          'hero.h1': 'Tarot that calls it like it is.',
          'hero.h2': 'Because most readings beat around the bush.',
          'hero.body': 'Cards called Sunday Scaries (9 of Swords), Quarter-Life Crisis (Judgement), and Dumpster Fire (the Tower). Pull one. It instantly makes sense.',
          'hero.featured-quote': '"It\'s delightful, and funny, and so fucking accurate I can\'t help but laugh… It\'s brilliant."',
          'hero.featured-quote-attr': '— @Indiedeckreview, 33K IG',
          'why.eyebrow': '✦ Why We Made It.',
          'why.h1': 'We like Tarot. But it can beat around the bush. This doesn\'t.',
          'why.sub': 'Same 78 cards. No hedging.',
          'why.before-content': 'You pull a card? "Not really my thing..."',
          'why.before-body': 'It\'s a guy in a robe holding a stick. The guidebook reads like it\'s afraid to say anything direct. Vague hedges, no actual takes.',
          'why.before-bullet-1': '❌ Read the guidebook, get vague hedges',
          'why.before-bullet-2': '❌ Try to extract an actual take',
          'why.before-bullet-3': '❌ Put the deck away. It didn\'t say anything.',
          'why.after-content': 'You pull a card? "Damn, I know what that\'s about."',
          'why.after-body': 'It\'s Big D Energy. The guidebook calls it like it sees it. Same wisdom, said the way an honest friend would.',
          'why.after-bullet-1': '✦ Pull a card. Read what it actually says.',
          'why.after-bullet-2': '✦ Get called out (kindly).',
          'why.after-bullet-3': '✦ No beating around the bush.',
          'why.featured-quote': '"Hysterical and weirdly accurate."',
          'why.featured-quote-attr': '— Kathy, Customer',
          'demo.eyebrow': '✦ OK, CALL ME OUT.',
          'demo.h1': 'Pull a card. It\'ll call it like it is.',
          'demo.featured-quote': '"Hysterical and weirdly accurate."',
          'demo.featured-quote-attr': '— Kathy, Customer',
          'guidebook.eyebrow': '✦ 132+ Pages of Real Tarot.',
          'guidebook.h1': 'Real tarot. Direct and no hedging.',
          'guidebook.sub': '132+ pages that make the meaning clear as day with some gentle sass. Plain English and color coordinated pages. Each deck comes with it\'s own guidebook.',
          'guidebook.structure-1': '"TL;DR" The whole reading in one line if that\'s all you need.',
          'guidebook.structure-2': '"The Sitch." What the card is actually saying about your week.',
          'guidebook.structure-3': '"Real Talk." The deeper guidance — what to do with it, said plainly.',
          'guidebook.structure-4': '"Reverse, Reverse." When the vibe flips, we tell you exactly how.',
          'guidebook.featured-quote': '"So fucking accurate I can\'t help but laugh."',
          'guidebook.featured-quote-attr': '— @Indiedeckreview, 33K IG',
          'reviews.eyebrow': '✦ From Owners Who Wanted The Truth.',
          'reviews.h1': 'Direct. Funny. Used nightly.',
          'reviews.featured': '"Hysterical and weirdly accurate."',
          'reviews.featured-attribution': 'Kathy, Customer',
          'founder.eyebrow': '✦ Who Made This. And Why.',
          'founder.h1': 'Skeptical, spiritual, somewhere in between.',
          'founder.body': 'Designed screens at Apple. Realized millennials wanted tools that talk like adults: direct, honest, no hedging. Built Millennial Tarot with one rule: the cards say the thing.',
          'founder.featured-quote': '"It captures the feeling of being a millennial in this world perfectly."',
          'founder.featured-quote-attr': '— @midheaventarot, Instagram',
          'founder.scott-bio': 'Ex-Apple UX designer. Built Millennial Tarot because millennials wanted spiritual tools that talk like adults: direct, honest, no hedging. Refined the deck across eight months in a Subaru and two Pacific Northwest retreat centers.',
          'inthewild.quote-2': '"Hysterical and weirdly accurate."',
          'inthewild.quote-2-attr': '— Kathy, Customer',
          'founder.hailey-bio': 'Moved Seattle to London on an Eat, Pray, Love impulse, answered a job ad for "Gen Z tarot writer" having never had a reading, and wrote an unhinged Empress card that got her the gig. Now lives in Germany finishing her Master\'s in global trade.'
        }
      }
    }
  },

  headline_v1: {
    description: 'Phase A: H1 alt rotation per theme. Stubbed; flip weights to activate.',
    weights: { base: 100, alt_a: 0, alt_b: 0 },
    variants: {
      base: {},
      alt_a: { themeText: { occult_belief: {}, meta_therapy: {}, millennial_era: {}, sassy_attitude: {} } },
      alt_b: { themeText: { occult_belief: {}, meta_therapy: {}, millennial_era: {}, sassy_attitude: {} } }
    }
  },

  offer_v1: {
    description: 'Phase B: offer/positioning axis. Activated after Phase A converges.',
    weights: { default: 100, bundle_theme_anchored: 0, bundle_relational: 0, bundle_2x_mt_gift: 0 },
    variants: { default: {}, bundle_theme_anchored: null, bundle_relational: null, bundle_2x_mt_gift: null }
  }

};
